import { Typography, CircularProgress } from '@mui/material';
import React from 'react';

import Box from 'src/components/Box';
import { useFeatureFlags } from 'src/hooks';

import styles from './styles';

type MatchedResourcesCountProps = {
  count: number;
  isLoading: boolean;
};

const MatchedResourcesCount: React.FC<MatchedResourcesCountProps> = props => {
  const { count, isLoading } = props;
  const { featureShowUpdatedSearch } = useFeatureFlags();

  return (
    <Box sx={styles.root}>
      <Typography variant="body1" component="span">
        Number of Talent matching your criteria: {featureShowUpdatedSearch && isLoading ? '' : count}
      </Typography>
      {isLoading && <CircularProgress size={20} sx={styles.circularProgress} />}
    </Box>
  );
};

export default MatchedResourcesCount;
